import { useEffect, useState } from 'react';
import { cooperplaceApi } from 'services/api';
import { KanbanContractError } from './contract';

const count = (value) => Number.isSafeInteger(value) && value >= 0;

/** Valida `GET control-tower/kanban/available-vehicles` e indexa os itens por carga. */
export function readAvailableVehicleCounts(data, loadIds) {
  const requested = new Set(loadIds);
  const valid =
    data &&
    typeof data.asOf === 'string' &&
    Array.isArray(data.items) &&
    data.items.length === requested.size &&
    data.items.every(
      (item) =>
        item &&
        requested.has(item.loadId) &&
        ((item.state === 'CALCULATED' &&
          count(item.eligibleCount) &&
          count(item.incompleteCount)) ||
          (item.state === 'UNAVAILABLE' && typeof item.message === 'string')),
    );
  if (!valid) throw new KanbanContractError('Resposta inválida da contagem de veículos.');
  return new Map(data.items.map((item) => [item.loadId, item]));
}

/**
 * Quantidade de veículos de cada carga da coluna Pré Cargas / Cargas, consultada depois do quadro
 * para não atrasá-lo. Falha ou resposta inválida só deixam o botão sem número.
 */
export default function useAvailableVehicleCounts({ companyId, group, enabled }) {
  const loadIds = [
    ...new Set((group?.data || []).filter((item) => item.type !== 'TRAVEL').map((i) => i.loadId)),
  ];
  // A data da consulta do grupo muda a cada atualização do quadro e refaz a contagem.
  const key = JSON.stringify([companyId, group?.asOf, loadIds]);
  const [state, setState] = useState({ key: null, counts: new Map() });
  const active = enabled && loadIds.length > 0;
  useEffect(() => {
    if (!active) return undefined;
    const abort = new AbortController();
    const ids = JSON.parse(key)[2];
    cooperplaceApi
      .get('control-tower/kanban/available-vehicles', {
        params: { loadIds: ids.join(',') },
        signal: abort.signal,
      })
      .then(({ data }) => readAvailableVehicleCounts(data, ids))
      .catch(() => new Map())
      .then((counts) => {
        if (!abort.signal.aborted) setState({ key, counts });
      });
    return () => abort.abort();
  }, [active, key]);
  return active && state.key === key ? state.counts : new Map();
}
